import { render, staticRenderFns } from "./HomeServices.vue?vue&type=template&id=81d3ea40&scoped=true&"
import script from "./HomeServices.vue?vue&type=script&lang=js&"
export * from "./HomeServices.vue?vue&type=script&lang=js&"
import style0 from "./HomeServices.vue?vue&type=style&index=0&id=81d3ea40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d3ea40",
  null
  
)

export default component.exports